import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Form } from "react-form";
import { connect } from "react-redux";

import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Toolbar from "@material-ui/core/Toolbar";
import Tooltip from "@material-ui/core/Tooltip";
import CircularProgress from "@material-ui/core/CircularProgress";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import CheckboxGroup from "../../common/CheckboxGroup";
import { MAKE_OPTIONS } from "../../../api/constants";

import { withStyles } from "@material-ui/core";
import ChevronRight from "@material-ui/icons/ChevronRight";
import AddCircle from "@material-ui/icons/AddCircle";
import EditIcon from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconButton from "@material-ui/core/IconButton";

import { AccomplishmentPlan, AccomplishmentBudget, AccomplishmentBudgetPersonnel, AccomplishmentBudgetCapitalEquipment } from "../models";

import TextField from "../../common/TextField";
import Checkbox from "../../common/Checkbox";
import RadioGroup from "../../common/RadioGroup";
import Subquestion from "../../common/Subquestion";
import WarningDialog from "../../common/WarningDialog";
import EnhancedTableHead from "../../common/EnhancedTableHead";
import CustomTableCell from "../../common/TableCell";
import HelpLabel from "../../common/HelpLabel";
import { createSelector } from "../../common/orm";
import { getValue } from "../../../api/utils";
import { budget_items } from "../../../api/constants";


const getBudgets = createSelector(
    (state, ownProps) => parseInt(ownProps.match.params["id"]),
    (session, id) => {
        return session.AccomplishmentBudget.filter({ accomplishment: id }).orderBy("order").toModelArray()
            .map(budget => ({
                _personnel: budget.budgetpersonnel.all().toRefArray(),
                _capital: budget.budgetcapital.all().toRefArray(),
                ...budget.ref
            }));;
    }
);


const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0
});

const numberRender = (rowData) => {
    return rowData ? formatter.format(rowData) : 0
};

const styles = theme => ({
    rightAlign: {
        textAlign: "right"
    },
    button: {
        marginRight: theme.spacing(2)
    },
    breakoutTable: {
        margin: 16,
        "& thead tr": {
            height: 40
        }
    },
    breakoutButton: {
        marginBottom: 16,
        color: "#fff !important"
    },
    checkbox: {
        display: "inline"
    },
    expansionSummaryRoot: {
        backgroundColor: "#eee",
        minHeight: 64,
        borderBottom: "1px dotted"
    },
    summaryRoot: {
        width: "100%",
        margin: "16px 0"
    },
    editIcon: {
        marginLeft: 8,
        marginBottom: -4
    },
    minWidth: {
        minWidth: 600
    },
    dialogMin: {
        minWidth: "400px",
        paddingTop: 0
    },
    flex: {
        flex: 1
    },
    deleteIcon: {
        float: "right"
    },
    table: {
        width: "100%",
        "& tbody tr:nth-child(even)": {
            backgroundColor: "#ffeff2"
        },
        marginBottom: 16
    },
    deleteWidth: {
        minWidth: 32,
        width: 32,
        height: 32,
        marginRight: 8,
    },
    centerAlign: {
        textAlign: "center"
    },
    nowrap: {
        whiteSpace: "nowrap"
    },
    totalRow: {
        backgroundColor: "rgb(221, 221, 221) !important",
        borderTop: "3px solid #000",
        height: 36
    },
    totalRow2: {
        backgroundColor: "rgb(221, 221, 221) !important",
        height: 36
    },
    widthSixty: {
        width: 160
    }
});

class BudgetTab extends Component {
    state = {
        partnershipActive: false,
        showRename: false,
        renameOpen: false,
        deleteOpen: false,
        renaming: null
    };
    parentFormKey = window.performance.now();

    /*shouldComponentUpdate(nextProps, nextState) {
        console.log(nextProps);
        console.log(nextState);
        console.log(this.props);
        console.log(this.state);
        console.log(nextProps.accomplishment_plan.contracts_included)
        console.log(this.props.accomplishment_plan.contracts_included)
        return (
            nextProps !== this.props || 
            nextState !== this.state
            //nextState.partnershipActive !== this.state.partnershipActive ||
            //nextState.renameOpen !== this.state.renameOpen ||
            ///
            //nextProps.proposal.personnel_past_requested !== this.props.proposal.personnel_past_requested
        );
    };*/

    componentDidMount() {
        const { handleUnsavedFields, accomplishment_plan } = this.props;
        this.props.onRef(this);
        document.title = "Accomplishment Plan: Budget - Lessard Sams Outdoor Heritage Council";
        const _this = this;
        // FIXME: react-forms calls formDidUpdate when (if) validation is ran right away
        // making it appear there is a edited field even if there isn't
        // Reset fields to false to not require validation when mounted
        setTimeout(function () {
            handleUnsavedFields(false);
            _this.props.appContainer.current.scrollTop();
        }, 1);

        if (getValue(accomplishment_plan, "is_partnership")) {
            this.setState({ partnershipActive: true });
        }
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    updateAP(values, fromStepper) {
        const { ormAccomplishmentPlanUpdate, history, handleUnsavedFields, handleNext, accomplishment_plan } = this.props;
        const { id } = accomplishment_plan;

        if (Number.isInteger(fromStepper)) {
            values.activeStep = fromStepper;
        }

        values.federal_funds_confirmation_document = accomplishment_plan.federal_funds_confirmation_document;
        values.modify_date_label = accomplishment_plan.modify_date_label;
        values.signup_criteria = accomplishment_plan.signup_criteria;

        ormAccomplishmentPlanUpdate({
            id: id,
            ...values
        });

        handleUnsavedFields(false);

        if (!Number.isInteger(fromStepper)) {
            if (this.state.draftClick) {
                history.push("/dashboard/");
            } else {
                handleNext();
            }
        }
    };

    groupBy = (list, keyGetter) => {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            } else {
                collection.push(item);
            }
        });
        return map;
    };

    returnDialog = () => {
        this.setState({ renameOpen: false });
    };

    togglePartnership = (checked) => {
        const { budgets, ormAccomplishmentBudgetUpdate } = this.props;
        this.setState({ partnershipActive: checked });
        if (checked) {
            budgets.forEach(function (b) {
                ormAccomplishmentBudgetUpdate({
                    id: b.id,
                    partnership: "New Partner 1"
                });
            });
        } else {
            budgets.forEach(function (b) {
                ormAccomplishmentBudgetUpdate({
                    id: b.id,
                    partnership: null
                });
            });
        }
    };

    addPartnership = () => {
        const { ormAccomplishmentBudgetCreate, accomplishment_plan, budgets } = this.props;
        const grouped = this.groupBy(budgets, b => b.partnership);

        budget_items.forEach(function (item, i) {
            var readonly = false;
            if (item === "Personnel" || item === "Capital Equipment" || item === "Grand Total")
                readonly = true;
            ormAccomplishmentBudgetCreate({
                accomplishment: accomplishment_plan.id,
                order: i,
                item: item,
                readonly: readonly,
                partnership: "New Partner " + (grouped.size + 1)
            })
        });
    };

    editPartnership = (name) => {
        this.setState({ renameOpen: true, renaming: name });
    };

    deletePartnership = (name) => {
        this.setState({ deleteOpen: true, renaming: name });
    };

    doDeletePartnership = (name) => {
        const { budgets, ormAccomplishmentBudgetDelete } = this.props;
        const grouped = this.groupBy(budgets, b => b.partnership);
        const partnershipsToDelete = grouped.get(name);
        partnershipsToDelete.forEach(function (p) {
            ormAccomplishmentBudgetDelete(p.id);
        });
        this.setState({ deleteOpen: false });
    };

    render() {
        const {
            classes,
            accomplishment_plan,
            handleUnsavedFields,
            budgets,
            ormAccomplishmentBudgetUpdate,
            ormAccomplishmentBudgetUpdateLocalOnly,
            ormAccomplishmentBudgetPersonnelCreate,
            ormAccomplishmentBudgetPersonnelUpdate,
            ormAccomplishmentBudgetPersonnelUpdateLocalOnly,
            ormAccomplishmentBudgetPersonnelDelete,
            ormAccomplishmentBudgetCapitalEquipmentCreate,
            ormAccomplishmentBudgetCapitalEquipmentUpdateLocalOnly,
            ormAccomplishmentBudgetCapitalEquipmentUpdate,
            ormAccomplishmentBudgetCapitalEquipmentDelete,
            ormAccomplishmentPlanUpdateLocalOnly,
            settings, authState
            //ActionMenu
        } = this.props;
        const { partnershipActive, renameOpen, deleteOpen, renaming } = this.state;
        var is_read_only = true;
        if ((authState && authState.user && authState.user.role === "admin") || (accomplishment_plan.status === "First Draft" || accomplishment_plan.status === "Approved First Draft" || accomplishment_plan.status === "Started Request for Amendment Change"))
            is_read_only = false;
        if (authState && authState.user && authState.user.role === "readonly")
            is_read_only = true;

        const grouped = this.groupBy(budgets, b => b.partnership);
        const groupedItem = this.groupBy(budgets, b => b.item);
        var pships = [];
        if (partnershipActive) {
            budgets.forEach(function (b) {
                if (!pships.includes(b.partnership)) {
                    pships.push(b.partnership);
                }
            });
        }

        var _t1 = budgets.filter(b => b.item === "Grand Total");
        var _funding_request = 0;
        _t1.forEach(function (t) {
            if (accomplishment_plan.status === "Started Request for Amendment Change" || accomplishment_plan.status === "Submitted Request for Amendment Change")
                _funding_request += t.funding_request_amend
            else
                _funding_request += t.funding_request
        })
        if (_funding_request !== accomplishment_plan.formData._t1) {
            accomplishment_plan.formData._t1 = _funding_request;
            this.parentFormKey = window.performance.now();
        }
        var temp = parseFloat(accomplishment_plan.funds_recommended.replace(/,/g, '')) - parseFloat(_funding_request);
        if (temp !== accomplishment_plan.formData._t4) {
            accomplishment_plan.formData._t4 = temp;
            this.parentFormKey = window.performance.now();
        }

        return (
            <>
                <Form
                    getApi={el => (this.form = el)}
                    dontValidateOnMount={true}
                    validateOnSubmit={true}
                    defaultValues={accomplishment_plan.formData}
                    formDidUpdate={() => handleUnsavedFields(true)}
                    onSubmit={(values, fromStepper) => this.updateAP(values, fromStepper)}>
                    {formApi => (
                        <form onSubmit={formApi.submitForm}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <HelpLabel
                                        inputLabel="Budget"
                                        title={true}
                                        showLabel={true}
                                        helpText={settings.budget_tab_help}
                                    />
                                    {/*ActionMenu*/}
                                </Grid>
                                <Grid item xs={12}>
                                    {partnershipActive && grouped.size > 1 && (
                                        <Tooltip title="Delete all but one partner to remove this partnership">
                                            <span>
                                                <Checkbox
                                                    field="is_partnership"
                                                    align={classes.checkbox}
                                                    disabled={true}
                                                    label="Partnership"
                                                >
                                                    <HelpLabel
                                                        inputLabel="Partnership"
                                                        helpText="A partnership budget should be included when different organizations are responsible for different activities AND those organizations will have a separate contract and submit separate reimbursements with the DNR that are not through the main manager of the program.  Please call to discuss if you think this applies to you."
                                                    />
                                                </Checkbox>
                                            </span>
                                        </Tooltip>
                                    )}
                                    {(!partnershipActive || grouped.size <= 1) && (
                                        <Checkbox
                                            field="is_partnership"
                                            eventHandle={this.togglePartnership}
                                            disabled={is_read_only}
                                            align={classes.checkbox}
                                            label="Partnership"
                                        >
                                            <HelpLabel
                                                inputLabel="Partnership"
                                                helpText="A partnership budget should be included when different organizations are responsible for different activities AND those organizations will have a separate contract and submit separate reimbursements with the DNR that are not through the main manager of the program.  Please call to discuss if you think this applies to you."
                                            />
                                        </Checkbox>
                                    )}
                                    {partnershipActive && (
                                        <Button
                                            variant="contained"
                                            type="button"
                                            color="primary"
                                            disabled={is_read_only}
                                            onClick={this.addPartnership}>
                                            <AddCircle />&nbsp;&nbsp;&nbsp;Add Additional Partner
                                        </Button>
                                    )}
                                    {partnershipActive && pships.map(p => {
                                        const groupedBudgetItems = grouped.get(p);
                                        return (
                                            <ExpansionPanel
                                                square
                                                defaultExpanded={false}
                                                classes={{ root: classes.summaryRoot }}
                                            >
                                                <ExpansionPanelSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    classes={{
                                                        root: classes.expansionSummaryRoot
                                                    }}>
                                                    <Typography variant="h3" style={{ width: "100%" }}>
                                                        {p}
                                                        <Tooltip title="Rename Partnership" placement="top">
                                                            <EditIcon disabled={is_read_only} onClick={(e) => { e.stopPropagation(); this.editPartnership(p) }} className={classes.editIcon} />
                                                        </Tooltip>
                                                        {grouped.size > 1 && (
                                                            <Tooltip title="Delete Partnership" placement="top">
                                                                <DeleteIcon disabled={is_read_only} onClick={(e) => { e.stopPropagation(); this.deletePartnership(p) }} className={classes.deleteIcon} />
                                                            </Tooltip>
                                                        )}
                                                    </Typography>
                                                </ExpansionPanelSummary>
                                                <ExpansionPanelDetails>
                                                    <Grid container>
                                                        <Grid item xs={12}>
                                                            <Typography variant="h3" gutterBottom>
                                                                Personnel - Breakout Details
                                                                <HelpLabel
                                                                    inputLabel="Directions for FTE / Salary calculations"
                                                                    special={true}
                                                                    helpText={
                                                                        <div>
                                                                            In order to consistently calculate the FTE and salary lines, please use the following guideline:<br /><br />
                                                                            Annual salary for that position <b>divided by</b> percent of time position will spend on OHF work per calendar year times number
                                                                            of years this position will work on the program = Amount anticipated to be reimbursed by OHF for this position in this program.<br /><br />
                                                                            Example:   $80,000 (annual salary) / .33 (percent amount of time) = 24,242.42 x 4 (years) = $96,968
                                                                        </div>
                                                                    }
                                                                />
                                                                <Button disabled={is_read_only} style={{ marginLeft: 16 }} variant="contained" color="primary" onClick={() => ormAccomplishmentBudgetPersonnelCreate({ budget: groupedBudgetItems.find(b => b.item === "Personnel").id })}>
                                                                    <AddCircle />
                                                                    &nbsp;&nbsp;&nbsp;Add Item
                                                                </Button>
                                                            </Typography>
                                                            <PersonnelTable
                                                                classes={classes}
                                                                budgets={groupedBudgetItems}
                                                                personnel_row={groupedBudgetItems.find(b => b.item === "Personnel")}
                                                                ormAccomplishmentBudgetPersonnelUpdate={ormAccomplishmentBudgetPersonnelUpdate}
                                                                ormAccomplishmentBudgetPersonnelUpdateLocalOnly={ormAccomplishmentBudgetPersonnelUpdateLocalOnly}
                                                                ormAccomplishmentBudgetPersonnelDelete={ormAccomplishmentBudgetPersonnelDelete}
                                                                ormAccomplishmentBudgetUpdate={ormAccomplishmentBudgetUpdate}
                                                                is_read_only={is_read_only}
                                                                ormAccomplishmentBudgetUpdateLocalOnly={ormAccomplishmentBudgetUpdateLocalOnly}
                                                                accomplishment_plan={accomplishment_plan}
                                                            />
                                                            <Typography variant="h3" gutterBottom>
                                                                Capital Equipment - Breakout Details (for items over $10,000)
                                                                <Button disabled={is_read_only} style={{ marginLeft: 16 }} variant="contained" color="primary" onClick={() => ormAccomplishmentBudgetCapitalEquipmentCreate({ budget: groupedBudgetItems.find(b => b.item === "Capital Equipment").id })}>
                                                                    <AddCircle />
                                                                    &nbsp;&nbsp;&nbsp;Add Item
                                                                </Button>
                                                            </Typography>
                                                            <CapitalTable
                                                                classes={classes}
                                                                budgets={groupedBudgetItems}
                                                                capital_row={groupedBudgetItems.find(b => b.item === "Capital Equipment")}
                                                                ormAccomplishmentBudgetCapitalEquipmentUpdate={ormAccomplishmentBudgetCapitalEquipmentUpdate}
                                                                ormAccomplishmentBudgetCapitalEquipmentUpdateLocalOnly={ormAccomplishmentBudgetCapitalEquipmentUpdateLocalOnly}
                                                                ormAccomplishmentBudgetCapitalEquipmentDelete={ormAccomplishmentBudgetCapitalEquipmentDelete}
                                                                ormAccomplishmentBudgetUpdate={ormAccomplishmentBudgetUpdate}
                                                                is_read_only={is_read_only}
                                                                ormAccomplishmentBudgetUpdateLocalOnly={ormAccomplishmentBudgetUpdateLocalOnly}
                                                                accomplishment_plan={accomplishment_plan}
                                                            />
                                                            <Typography variant="h3" gutterBottom style={{ display: "inline" }}>
                                                                Main Budget Table
                                                            </Typography>
                                                            <Form
                                                                key={this.parentFormKey}
                                                                dontValidateOnMount={true}
                                                                validateOnSubmit={true}
                                                                defaultValues={accomplishment_plan.formData}>
                                                                {formApi => (
                                                                    <form onSubmit={formApi.submitForm}>
                                                                        <div style={{ float: "right", marginTop: -20 }}>
                                                                            <TextField
                                                                                disabled={true}
                                                                                field="funds_recommended" 
                                                                                useTextFormat
                                                                                className={classes.widthSixty}
                                                                            >
                                                                                <i style={{ textAlign: 'center', display: "block" }}>Appropriated Amount</i>
                                                                            </TextField>
                                                                            <span style={{ marginLeft: 5, marginRight: 5, marginTop: 45, display: "inline-block" }}>-</span>
                                                                            <TextField
                                                                                disabled={true}
                                                                                field="_t1" 
                                                                                useTextFormat
                                                                                className={classes.widthSixty}
                                                                            >
                                                                                <i style={{ textAlign: 'center', display: "block" }}>Amount Spent</i>
                                                                            </TextField>
                                                                            <span style={{ marginLeft: 5, marginRight: 5, marginTop: 45, display: "inline-block" }}>=</span>
                                                                            <TextField
                                                                                disabled={true}
                                                                                field="_t4" 
                                                                                useTextFormat
                                                                                color={accomplishment_plan.formData._t4 === 0 ? "green" : accomplishment_plan.formData._t4 > 0 ? "yellow" : "red"}
                                                                                className={classes.widthSixty}
                                                                            >
                                                                                <i style={{ textAlign: 'center', display: "block" }}>Balance Left Unspent</i>
                                                                            </TextField>
                                                                        </div>
                                                                    </form>
                                                                )}
                                                            </Form>
                                                            {(accomplishment_plan.status === "Started Request for Amendment Change" || accomplishment_plan.status === "Submitted Request for Amendment Change") ? (
                                                                <BudgetTableAmendment
                                                                    ormAccomplishmentBudgetUpdate={ormAccomplishmentBudgetUpdate}
                                                                    ormAccomplishmentBudgetUpdateLocalOnly={ormAccomplishmentBudgetUpdateLocalOnly}
                                                                    rows={groupedBudgetItems}
                                                                    is_read_only={is_read_only}
                                                                    classes={classes}
                                                                />
                                                            ) : (
                                                                <BudgetTable
                                                                    ormAccomplishmentBudgetUpdate={ormAccomplishmentBudgetUpdate}
                                                                    ormAccomplishmentBudgetUpdateLocalOnly={ormAccomplishmentBudgetUpdateLocalOnly}
                                                                    rows={groupedBudgetItems}
                                                                    is_read_only={is_read_only}
                                                                    classes={classes}
                                                                />
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </ExpansionPanelDetails>
                                            </ExpansionPanel>
                                        )
                                    })}
                                    {!partnershipActive && (
                                        <>
                                            <Typography variant="h3" gutterBottom>
                                                Personnel - Breakout Details
                                                <HelpLabel
                                                    inputLabel="Directions for FTE / Salary calculations"
                                                    special={true}
                                                    helpText={
                                                        <div>
                                                            In order to consistently calculate the FTE and salary lines, please use the following guideline:<br /><br />
                                                            Annual salary for that position <b>divided by</b> percent of time position will spend on OHF work per calendar year times number
                                                            of years this position will work on the program = Amount anticipated to be reimbursed by OHF for this position in this program.<br /><br />
                                                            Example:   $80,000 (annual salary) / .33 (percent amount of time) = 24,242.42 x 4 (years) = $96,968
                                                        </div>
                                                    }
                                                />
                                                <Button disabled={is_read_only} style={{ marginLeft: 16 }} variant="contained" color="primary" onClick={() => ormAccomplishmentBudgetPersonnelCreate({ budget: budgets.find(b => b.item === "Personnel").id })}>
                                                    <AddCircle />
                                                    &nbsp;&nbsp;&nbsp;Add Item
                                                </Button>
                                            </Typography>
                                            <PersonnelTable
                                                classes={classes}
                                                budgets={budgets}
                                                personnel_row={budgets.find(b => b.item === "Personnel")}
                                                ormAccomplishmentBudgetPersonnelUpdate={ormAccomplishmentBudgetPersonnelUpdate}
                                                ormAccomplishmentBudgetPersonnelUpdateLocalOnly={ormAccomplishmentBudgetPersonnelUpdateLocalOnly}
                                                ormAccomplishmentBudgetPersonnelDelete={ormAccomplishmentBudgetPersonnelDelete}
                                                ormAccomplishmentBudgetUpdate={ormAccomplishmentBudgetUpdate}
                                                is_read_only={is_read_only}
                                                ormAccomplishmentBudgetUpdateLocalOnly={ormAccomplishmentBudgetUpdateLocalOnly}
                                                accomplishment_plan={accomplishment_plan}
                                            />
                                            <Typography variant="h3" gutterBottom>
                                                Capital Equipment - Breakout Details (for items over $10,000)
                                                <Button disabled={is_read_only} style={{ marginLeft: 16 }} variant="contained" color="primary" onClick={() => ormAccomplishmentBudgetCapitalEquipmentCreate({ budget: budgets.find(b => b.item === "Capital Equipment").id })}>
                                                    <AddCircle />
                                                    &nbsp;&nbsp;&nbsp;Add Item
                                                </Button>
                                            </Typography>
                                            <CapitalTable
                                                classes={classes}
                                                budgets={budgets}
                                                capital_row={budgets.find(b => b.item === "Capital Equipment")}
                                                ormAccomplishmentBudgetCapitalEquipmentUpdate={ormAccomplishmentBudgetCapitalEquipmentUpdate}
                                                ormAccomplishmentBudgetCapitalEquipmentUpdateLocalOnly={ormAccomplishmentBudgetCapitalEquipmentUpdateLocalOnly}
                                                ormAccomplishmentBudgetCapitalEquipmentDelete={ormAccomplishmentBudgetCapitalEquipmentDelete}
                                                ormAccomplishmentBudgetUpdate={ormAccomplishmentBudgetUpdate}
                                                is_read_only={is_read_only}
                                                ormAccomplishmentBudgetUpdateLocalOnly={ormAccomplishmentBudgetUpdateLocalOnly}
                                                accomplishment_plan={accomplishment_plan}
                                            />
                                            <Typography variant="h3" gutterBottom style={{ display: "inline" }}>
                                                Main Budget Table
                                            </Typography>
                                            <Form
                                                key={this.parentFormKey}
                                                dontValidateOnMount={true}
                                                validateOnSubmit={true}
                                                defaultValues={accomplishment_plan.formData}>
                                                {formApi => (
                                                    <form onSubmit={formApi.submitForm}>
                                                        <div style={{ float: "right", marginTop: -20 }}>
                                                            <TextField
                                                                disabled={true}
                                                                field="funds_recommended" 
                                                                useTextFormat
                                                                className={classes.widthSixty}
                                                            >
                                                                <i style={{ textAlign: 'center', display: "block" }}>Appropriated Amount</i>
                                                            </TextField>
                                                            <span style={{ marginLeft: 5, marginRight: 5, marginTop: 45, display: "inline-block" }}>-</span>
                                                            <TextField
                                                                disabled={true}
                                                                field="_t1" 
                                                                useTextFormat
                                                                className={classes.widthSixty}
                                                            >
                                                                <i style={{ textAlign: 'center', display: "block" }}>Amount Spent</i>
                                                            </TextField>
                                                            <span style={{ marginLeft: 5, marginRight: 5, marginTop: 45, display: "inline-block" }}>=</span>
                                                            <TextField
                                                                disabled={true}
                                                                field="_t4" useTextFormat
                                                                color={accomplishment_plan.formData._t4 === 0 ? "green" : accomplishment_plan.formData._t4 > 0 ? "yellow" : "red"}
                                                                className={classes.widthSixty}
                                                            >
                                                                <i style={{ textAlign: 'center', display: "block" }}>Balance Left Unspent</i>
                                                            </TextField>
                                                        </div>
                                                    </form>
                                                )}
                                            </Form>
                                            {(accomplishment_plan.status === "Started Request for Amendment Change" || accomplishment_plan.status === "Submitted Request for Amendment Change") ? (
                                                <BudgetTableAmendment
                                                    ormAccomplishmentBudgetUpdate={ormAccomplishmentBudgetUpdate}
                                                    ormAccomplishmentBudgetUpdateLocalOnly={ormAccomplishmentBudgetUpdateLocalOnly}
                                                    rows={budgets}
                                                    is_read_only={is_read_only}
                                                    classes={classes}
                                                />
                                            ) : (
                                                <BudgetTable
                                                    ormAccomplishmentBudgetUpdate={ormAccomplishmentBudgetUpdate}
                                                    ormAccomplishmentBudgetUpdateLocalOnly={ormAccomplishmentBudgetUpdateLocalOnly}
                                                    rows={budgets}
                                                    is_read_only={is_read_only}
                                                    classes={classes}
                                                />
                                            )}
                                        </>
                                    )}
                                    {partnershipActive && grouped.size > 1 && (
                                        <ExpansionPanel
                                            square
                                            defaultExpanded={true}
                                            classes={{ root: classes.summaryRoot }}
                                        >
                                            <ExpansionPanelSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                classes={{
                                                    root: classes.expansionSummaryRoot
                                                }}>
                                                <Typography variant="h3" style={{ width: "100%" }}>Grand Totals Across All Partners</Typography>
                                            </ExpansionPanelSummary>
                                            <ExpansionPanelDetails>
                                                {(accomplishment_plan.status === "Started Request for Amendment Change" || accomplishment_plan.status === "Submitted Request for Amendment Change") ? (
                                                    <BudgetTableTotalAmendment rows={budgets} classes={classes} />
                                                ) : (
                                                    <BudgetTableTotal rows={budgets} classes={classes} />
                                                )}
                                            </ExpansionPanelDetails>
                                        </ExpansionPanel>
                                    )}
                                </Grid>
                            </Grid>
                            <Grid container spacing={1}>
                                <OtherFields is_read_only={is_read_only} groupedItem={groupedItem} accomplishment_plan={accomplishment_plan} ormAccomplishmentPlanUpdateLocalOnly={ormAccomplishmentPlanUpdateLocalOnly} />
                                <Grid item xs={12} className={classes.rightAlign}>
                                    <Button
                                        variant="contained"
                                        disabled={is_read_only}
                                        type="submit"
                                        onClick={() => this.setState({ draftClick: true, submitClicked: true })}
                                        className={classes.button}>
                                        Save Draft and Return to Dashboard
                                    </Button>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        disabled={is_read_only}
                                        color="primary"
                                        onClick={() => this.setState({ draftClick: false, submitClicked: true })}>
                                        Save and Proceed to Federal Funds <ChevronRight />
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Form>
                <RenamePartnership
                    ormAccomplishmentBudgetUpdate={ormAccomplishmentBudgetUpdate}
                    budgets={grouped.get(renaming)}
                    classes={classes}
                    returnDialog={this.returnDialog}
                    open={renameOpen}
                    name={renaming}
                />
                <WarningDialog
                    confirmAction={() => this.doDeletePartnership(renaming)}
                    cancelAction={() => this.setState({ deleteOpen: false })}
                    open={deleteOpen}
                    title="Delete Partner"
                    confirmText="Delete Partner"
                    text={"Are you sure you wish to delete " + renaming + "? Any budget values entered for this partner will be lost."}
                />
            </>
        );
    }
}

class PersonnelTable extends Component {
    columnData = [
        { id: "position", label: "Position", allowSort: false },
        { id: "fte", label: "Annual FTE Equivalent", allowSort: false },
        { id: "years_working", label: "Years Working on Program", allowSort: false },
        { id: "funding_request", label: "Funding Request", allowSort: false },
        { id: "anticipated_leverage", label: "Leverage", allowSort: false },
        { id: "leverage_source", label: "Leverage Source", allowSort: false },
        { id: "total", label: "Total", allowSort: false },
        { id: "actions", numeric: false, label: "Actions", allowSort: false, width: "20px" }
    ];
    typingTimer = [];
    typingTimer2 = [];
    objectsToUpdate = [];
    formkeys = {};

    updateRecord = (value, element, id, record) => {
        const { accomplishment_plan, ormAccomplishmentBudgetPersonnelUpdate, ormAccomplishmentBudgetPersonnelUpdateLocalOnly, personnel_row, ormAccomplishmentBudgetUpdateLocalOnly, ormAccomplishmentBudgetUpdate, budgets } = this.props;
        const comp = this;

        // Save each individual value locally
        clearTimeout(this.typingTimer2[id + element]);
        this.typingTimer2[id + element] = setTimeout(function () {

            if (element === "funding_request" || element === "anticipated_leverage")
                value = (Math.round(parseInt(value) / 100) * 100) || 0;
            else if (!value && (element === "fte" || element === "years_working"))
                value = 0;

            var vals = {
                id: id,
                [element]: value
            }
            if (element === "funding_request") {
                if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage"])
                    vals["total"] = value + comp.objectsToUpdate[id]["anticipated_leverage"];
                else
                    vals["total"] = value + record.anticipated_leverage;
            }
            else if (element === "anticipated_leverage") {
                if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request"])
                    vals["total"] = value + comp.objectsToUpdate[id]["funding_request"];
                else
                    vals["total"] = value + record.funding_request;
            } else {
                vals["total"] = record.funding_request + record.anticipated_leverage;
            }
            ormAccomplishmentBudgetPersonnelUpdateLocalOnly(vals);
            comp.objectsToUpdate[id] = { ...comp.objectsToUpdate[id], ...vals };

            if (element !== "funding_request" && element !== "anticipated_leverage" && element !== "leverage_source")
                return;

            var totals = {}, grand_totals = {};
            var leverage_array = []; var uniq;
            if (accomplishment_plan.status === "Started Request for Amendment Change" || accomplishment_plan.status === "Submitted Request for Amendment Change") {
                totals = {
                    id: personnel_row.id,
                    funding_request_amend: 0,
                    anticipated_leverage_amend: 0,
                    total_amend: 0,
                    leverage_source: null
                };
                personnel_row._personnel.forEach(function (p) {
                    if (p.id === id) {
                        if (element === "funding_request") {
                            totals["funding_request_amend"] += value;
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage"])
                                totals["anticipated_leverage_amend"] += comp.objectsToUpdate[id]["anticipated_leverage"];
                            else
                                totals["anticipated_leverage_amend"] += (parseInt(p.anticipated_leverage) || 0);
                        }
                        else if (element === "anticipated_leverage") {
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request"])
                                totals["funding_request_amend"] += comp.objectsToUpdate[id]["funding_request"];
                            else
                                totals["funding_request_amend"] += (parseInt(p.funding_request) || 0);
                            totals["anticipated_leverage_amend"] += value;
                        } else {
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request"])
                                totals["funding_request_amend"] += comp.objectsToUpdate[id]["funding_request"];
                            else
                                totals["funding_request_amend"] += (parseInt(p.funding_request) || 0);
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage"])
                                totals["anticipated_leverage_amend"] += comp.objectsToUpdate[id]["anticipated_leverage"];
                            else
                                totals["anticipated_leverage_amend"] += (parseInt(p.anticipated_leverage) || 0);
                        }
                        totals["total_amend"] += vals["total"];
                        if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["leverage_source"])
                            leverage_array.push(comp.objectsToUpdate[id]["leverage_source"]);
                        else if (element !== "leverage_source")
                            leverage_array.push(p.leverage_source);
                    } else {
                        totals["funding_request_amend"] += (parseInt(p.funding_request) || 0);
                        totals["anticipated_leverage_amend"] += (parseInt(p.anticipated_leverage) || 0);
                        totals["total_amend"] += (parseInt(p.total) || 0);
                        leverage_array.push(p.leverage_source);
                    }
                });
                uniq = [...new Set(leverage_array)];
                totals["leverage_source"] = uniq.filter(n => n).join(", ");

                grand_totals = {
                    id: budgets.find(b => b.item === "Grand Total").id,
                    funding_request_amend: totals["funding_request_amend"],
                    anticipated_leverage_amend: totals["anticipated_leverage_amend"],
                    total_amend: totals["total_amend"]
                };
                budgets.forEach(function (b) {
                    if (b.item !== "Personnel" && b.item !== "Grand Total") {
                        grand_totals["funding_request_amend"] += b.funding_request_amend;
                        grand_totals["anticipated_leverage_amend"] += b.anticipated_leverage_amend;
                        grand_totals["total_amend"] += b.total_amend;
                    }
                });
            } else {
                totals = {
                    id: personnel_row.id,
                    funding_request: 0,
                    anticipated_leverage: 0,
                    total: 0,
                    leverage_source: null
                };
                personnel_row._personnel.forEach(function (p) {
                    if (p.id === id) {
                        if (element === "funding_request") {
                            totals["funding_request"] += value;
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage"])
                                totals["anticipated_leverage"] += comp.objectsToUpdate[id]["anticipated_leverage"];
                            else
                                totals["anticipated_leverage"] += (parseInt(p.anticipated_leverage) || 0);
                        }
                        else if (element === "anticipated_leverage") {
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request"])
                                totals["funding_request"] += comp.objectsToUpdate[id]["funding_request"];
                            else
                                totals["funding_request"] += (parseInt(p.funding_request) || 0);
                            totals["anticipated_leverage"] += value;
                        } else {
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request"])
                                totals["funding_request"] += comp.objectsToUpdate[id]["funding_request"];
                            else
                                totals["funding_request"] += (parseInt(p.funding_request) || 0);
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage"])
                                totals["anticipated_leverage"] += comp.objectsToUpdate[id]["anticipated_leverage"];
                            else
                                totals["anticipated_leverage"] += (parseInt(p.anticipated_leverage) || 0);
                        }
                        totals["total"] += vals["total"];
                        if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["leverage_source"])
                            leverage_array.push(comp.objectsToUpdate[id]["leverage_source"]);
                        else if (element !== "leverage_source")
                            leverage_array.push(p.leverage_source);
                    } else {
                        totals["funding_request"] += (parseInt(p.funding_request) || 0);
                        totals["anticipated_leverage"] += (parseInt(p.anticipated_leverage) || 0);
                        totals["total"] += (parseInt(p.total) || 0);
                        leverage_array.push(p.leverage_source);
                    }
                });
                uniq = [...new Set(leverage_array)];
                totals["leverage_source"] = uniq.filter(n => n).join(", ");

                grand_totals = {
                    id: budgets.find(b => b.item === "Grand Total").id,
                    funding_request: totals["funding_request"],
                    anticipated_leverage: totals["anticipated_leverage"],
                    total: totals["total"]
                };
                budgets.forEach(function (b) {
                    if (b.item !== "Personnel" && b.item !== "Grand Total") {
                        grand_totals["funding_request"] += b.funding_request;
                        grand_totals["anticipated_leverage"] += b.anticipated_leverage;
                        grand_totals["total"] += b.total;
                    }
                });
            }

            ormAccomplishmentBudgetUpdateLocalOnly(totals);
            ormAccomplishmentBudgetUpdateLocalOnly(grand_totals);

            // Later properties overwrite earlier properties with the same name.
            comp.objectsToUpdate["parent"] = { ...comp.objectsToUpdate["parent"], ...totals };
            comp.objectsToUpdate["grand_parent"] = { ...comp.objectsToUpdate["grand_parent"], ...grand_totals };
        }, 50);

        // Save the row once finished editing
        clearTimeout(this.typingTimer[id]);
        this.typingTimer[id] = setTimeout(function () {
            ormAccomplishmentBudgetPersonnelUpdate(comp.objectsToUpdate[id]);
        }, 2500);

        // Parent Total
        clearTimeout(this.typingTimer["parent"]);
        this.typingTimer["parent"] = setTimeout(function () {
            if (comp.objectsToUpdate["parent"]) {
                ormAccomplishmentBudgetUpdate(comp.objectsToUpdate["parent"]);
                ormAccomplishmentBudgetUpdate(comp.objectsToUpdate["grand_parent"]);
            }
        }, 2500);
    };

    recalculateTotal = (deleteId) => {
        const { accomplishment_plan, ormAccomplishmentBudgetUpdate, budgets, personnel_row, ormAccomplishmentBudgetPersonnelDelete } = this.props;

        var totals = {};
        var grand_totals = {};
        var leverage_array = [];
        var uniq;
        if (accomplishment_plan.status === "Started Request for Amendment Change" || accomplishment_plan.status === "Submitted Request for Amendment Change") {
            totals = {
                id: personnel_row.id,
                funding_request_amend: 0,
                anticipated_leverage_amend: 0,
                total_amend: 0,
                leverage_source: null
            };

            personnel_row._personnel.forEach(function (p) {
                if (p.id !== deleteId) {
                    totals["funding_request_amend"] += (parseInt(p.funding_request) || 0);
                    totals["anticipated_leverage_amend"] += (parseInt(p.anticipated_leverage) || 0);
                    totals["total_amend"] += (parseInt(p.total) || 0);
                    leverage_array.push(p.leverage_source);
                }
            });
            uniq = [...new Set(leverage_array)];
            totals["leverage_source"] = uniq.filter(n => n).join(", ");

            grand_totals = {
                id: budgets.find(b => b.item === "Grand Total").id,
                funding_request_amend: totals["funding_request_amend"],
                anticipated_leverage_amend: totals["anticipated_leverage_amend"],
                total_amend: totals["total_amend"]
            };
            budgets.forEach(function (b) {
                if (b.item !== "Personnel" && b.item !== "Grand Total") {
                    grand_totals["funding_request_amend"] += b.funding_request_amend;
                    grand_totals["anticipated_leverage_amend"] += b.anticipated_leverage_amend;
                    grand_totals["total_amend"] += b.total_amend;
                }
            });
        } else {
            totals = {
                id: personnel_row.id,
                funding_request: 0,
                anticipated_leverage: 0,
                total: 0,
                leverage_source: null
            };
            personnel_row._personnel.forEach(function (p) {
                if (p.id !== deleteId) {
                    totals["funding_request"] += (parseInt(p.funding_request) || 0);
                    totals["anticipated_leverage"] += (parseInt(p.anticipated_leverage) || 0);
                    totals["total"] += (parseInt(p.total) || 0);
                    leverage_array.push(p.leverage_source);
                }
            });
            uniq = [...new Set(leverage_array)];
            totals["leverage_source"] = uniq.filter(n => n).join(", ");

            grand_totals = {
                id: budgets.find(b => b.item === "Grand Total").id,
                funding_request: totals["funding_request"],
                anticipated_leverage: totals["anticipated_leverage"],
                total: totals["total"]
            };
            budgets.forEach(function (b) {
                if (b.item !== "Personnel" && b.item !== "Grand Total") {
                    grand_totals["funding_request"] += b.funding_request;
                    grand_totals["anticipated_leverage"] += b.anticipated_leverage;
                    grand_totals["total"] += b.total;
                }
            });
        }

        ormAccomplishmentBudgetPersonnelDelete(deleteId);
        ormAccomplishmentBudgetUpdate(totals);
        ormAccomplishmentBudgetUpdate(grand_totals);
    }

    updateForm = (field, id) => {
        this.formkeys[id + field] = window.performance.now();
        this.setState({ foo: "bar" });
    };

    render() {
        const { classes, personnel_row, is_read_only } = this.props;

        return (
            <Table className={classes.table}>
                <EnhancedTableHead columnData={this.columnData} />
                <TableBody>
                    {personnel_row && personnel_row._personnel.map(n => {
                        return (
                            <TableRow hover key={n.id}>
                                <CustomTableCell>
                                    <Form key={n.id + "position"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    tableFormat
                                                    eventHandleProps1={n.id}
                                                    eventHandleProps2={n}
                                                    eventHandle={this.updateRecord}
                                                    field="position"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={n.id + "fte"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    tableFormat
                                                    useAcres
                                                    eventHandleProps1={n.id}
                                                    eventHandleProps2={n}
                                                    eventHandle={this.updateRecord}
                                                    field="fte"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={n.id + "years_working"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    tableFormat
                                                    useAcres
                                                    eventHandleProps1={n.id}
                                                    eventHandleProps2={n}
                                                    eventHandle={this.updateRecord}
                                                    field="years_working"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={this.formkeys[n.id + "funding_request"] ? this.formkeys[n.id + "funding_request"] : n.id + "funding_request"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    onBlur={this.updateForm}
                                                    eventHandleProps1={n.id}
                                                    eventHandleProps2={n}
                                                    tableFormat
                                                    useTextFormat
                                                    eventHandle={this.updateRecord}
                                                    field="funding_request"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={this.formkeys[n.id + "anticipated_leverage"] ? this.formkeys[n.id + "anticipated_leverage"] : n.id + "anticipated_leverage"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    onBlur={this.updateForm}
                                                    eventHandleProps1={n.id}
                                                    eventHandleProps2={n}
                                                    tableFormat
                                                    useTextFormat
                                                    eventHandle={this.updateRecord}
                                                    field="anticipated_leverage"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={n.id + "leverage_source"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    tableFormat
                                                    eventHandleProps1={n.id}
                                                    eventHandle={this.updateRecord}
                                                    eventHandleProps2={n}
                                                    field="leverage_source"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    {numberRender(n.total)}
                                </CustomTableCell>
                                <CustomTableCell className={classes.nowrap}>
                                    <Tooltip title="Delete Record">
                                        <Button
                                            color="primary"
                                            disabled={is_read_only}
                                            className={classes.deleteWidth}
                                            onClick={() => this.recalculateTotal(n.id)}>
                                            <DeleteIcon color="primary" />
                                        </Button>
                                    </Tooltip>
                                </CustomTableCell>
                            </TableRow>
                        );
                    })}
                    {(!personnel_row || personnel_row._personnel < 1) && (
                        <TableRow className={classes.totalRow2}>
                            <CustomTableCell colSpan={this.columnData.length} className={classes.centerAlign}>
                                No Records Found
                            </CustomTableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        );
    }
}

class CapitalTable extends Component {
    columnData = [
        { id: "position", label: "Item", allowSort: false },
        { id: "funding_request", label: "Funding Request", allowSort: false },
        { id: "anticipated_leverage", label: "Leverage", allowSort: false },
        { id: "leverage_source", label: "Leverage Source", allowSort: false },
        { id: "total", label: "Total", allowSort: false },
        { id: "actions", numeric: false, label: "Actions", allowSort: false, width: "20px" }
    ];
    typingTimer = [];
    typingTimer2 = [];
    objectsToUpdate = [];
    formkeys = {};

    updateRecord = (value, element, id, record) => {
        const { accomplishment_plan, ormAccomplishmentBudgetCapitalEquipmentUpdate, ormAccomplishmentBudgetCapitalEquipmentUpdateLocalOnly, capital_row, ormAccomplishmentBudgetUpdateLocalOnly, ormAccomplishmentBudgetUpdate, budgets } = this.props;
        const comp = this;

        // Save each individual value locally
        clearTimeout(this.typingTimer2[id + element]);
        this.typingTimer2[id + element] = setTimeout(function () {

            if (element === "funding_request" || element === "anticipated_leverage")
                value = (Math.round(parseInt(value) / 100) * 100) || 0;

            var vals = {
                id: id,
                [element]: value
            }
            if (element === "funding_request") {
                if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage"])
                    vals["total"] = value + comp.objectsToUpdate[id]["anticipated_leverage"];
                else
                    vals["total"] = value + record.anticipated_leverage;
            }
            else if (element === "anticipated_leverage") {
                if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request"])
                    vals["total"] = value + comp.objectsToUpdate[id]["funding_request"];
                else
                    vals["total"] = value + record.funding_request;
            } else {
                vals["total"] = record.funding_request + record.anticipated_leverage;
            }
            ormAccomplishmentBudgetCapitalEquipmentUpdateLocalOnly(vals);
            comp.objectsToUpdate[id] = { ...comp.objectsToUpdate[id], ...vals };

            if (element !== "funding_request" && element !== "anticipated_leverage" && element !== "leverage_source")
                return;

            var totals = {}, grand_totals = {};
            var leverage_array = []; var uniq;
            if (accomplishment_plan.status === "Started Request for Amendment Change" || accomplishment_plan.status === "Submitted Request for Amendment Change") {
                totals = {
                    id: capital_row.id,
                    funding_request_amend: 0,
                    anticipated_leverage_amend: 0,
                    total_amend: 0,
                    leverage_source: null
                };
                capital_row._capital.forEach(function (p) {
                    if (p.id === id) {
                        if (element === "funding_request") {
                            totals["funding_request_amend"] += value;
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage"])
                                totals["anticipated_leverage_amend"] += comp.objectsToUpdate[id]["anticipated_leverage"];
                            else
                                totals["anticipated_leverage_amend"] += (parseInt(p.anticipated_leverage) || 0);
                        }
                        else if (element === "anticipated_leverage") {
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request"])
                                totals["funding_request_amend"] += comp.objectsToUpdate[id]["funding_request"];
                            else
                                totals["funding_request_amend"] += (parseInt(p.funding_request) || 0);
                            totals["anticipated_leverage_amend"] += value;
                        } else {
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request"])
                                totals["funding_request_amend"] += comp.objectsToUpdate[id]["funding_request"];
                            else
                                totals["funding_request_amend"] += (parseInt(p.funding_request) || 0);

                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage"])
                                totals["anticipated_leverage_amend"] += comp.objectsToUpdate[id]["anticipated_leverage"];
                            else
                                totals["anticipated_leverage_amend"] += (parseInt(p.anticipated_leverage) || 0);
                        }
                        totals["total_amend"] += vals["total"];
                        if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["leverage_source"])
                            leverage_array.push(comp.objectsToUpdate[id]["leverage_source"]);
                        else if (element !== "leverage_source")
                            leverage_array.push(p.leverage_source);
                    } else {
                        totals["funding_request_amend"] += (parseInt(p.funding_request) || 0);
                        totals["anticipated_leverage_amend"] += (parseInt(p.anticipated_leverage) || 0);
                        totals["total_amend"] += (parseInt(p.total) || 0);
                        leverage_array.push(p.leverage_source);
                    }
                });
                uniq = [...new Set(leverage_array)];
                totals["leverage_source"] = uniq.filter(n => n).join(", ");

                grand_totals = {
                    id: budgets.find(b => b.item === "Grand Total").id,
                    funding_request_amend: totals["funding_request_amend"],
                    anticipated_leverage_amend: totals["anticipated_leverage_amend"],
                    total_amend: totals["total_amend"]
                };
                budgets.forEach(function (b) {
                    if (b.item !== "Capital Equipment" && b.item !== "Grand Total") {
                        grand_totals["funding_request_amend"] += b.funding_request_amend;
                        grand_totals["anticipated_leverage_amend"] += b.anticipated_leverage_amend;
                        grand_totals["total_amend"] += b.total_amend;
                    }
                });
            } else {
                totals = {
                    id: capital_row.id,
                    funding_request: 0,
                    anticipated_leverage: 0,
                    total: 0,
                    leverage_source: null
                };
                capital_row._capital.forEach(function (p) {
                    if (p.id === id) {
                        if (element === "funding_request") {
                            totals["funding_request"] += value;
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage"])
                                totals["anticipated_leverage"] += comp.objectsToUpdate[id]["anticipated_leverage"];
                            else
                                totals["anticipated_leverage"] += (parseInt(p.anticipated_leverage) || 0);
                        }
                        else if (element === "anticipated_leverage") {
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request"])
                                totals["funding_request"] += comp.objectsToUpdate[id]["funding_request"];
                            else
                                totals["funding_request"] += (parseInt(p.funding_request) || 0);
                            totals["anticipated_leverage"] += value;
                        } else {
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request"])
                                totals["funding_request"] += comp.objectsToUpdate[id]["funding_request"];
                            else
                                totals["funding_request"] += (parseInt(p.funding_request) || 0);

                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage"])
                                totals["anticipated_leverage"] += comp.objectsToUpdate[id]["anticipated_leverage"];
                            else
                                totals["anticipated_leverage"] += (parseInt(p.anticipated_leverage) || 0);
                        }
                        totals["total"] += vals["total"];
                        if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["leverage_source"])
                            leverage_array.push(comp.objectsToUpdate[id]["leverage_source"]);
                        else if (element !== "leverage_source")
                            leverage_array.push(p.leverage_source);
                    } else {
                        totals["funding_request"] += (parseInt(p.funding_request) || 0);
                        totals["anticipated_leverage"] += (parseInt(p.anticipated_leverage) || 0);
                        totals["total"] += (parseInt(p.total) || 0);
                        leverage_array.push(p.leverage_source);
                    }
                });
                uniq = [...new Set(leverage_array)];
                totals["leverage_source"] = uniq.filter(n => n).join(", ");

                grand_totals = {
                    id: budgets.find(b => b.item === "Grand Total").id,
                    funding_request: totals["funding_request"],
                    anticipated_leverage: totals["anticipated_leverage"],
                    total: totals["total"]
                };
                budgets.forEach(function (b) {
                    if (b.item !== "Capital Equipment" && b.item !== "Grand Total") {
                        grand_totals["funding_request"] += b.funding_request;
                        grand_totals["anticipated_leverage"] += b.anticipated_leverage;
                        grand_totals["total"] += b.total;
                    }
                });
            }

            ormAccomplishmentBudgetUpdateLocalOnly(totals);
            ormAccomplishmentBudgetUpdateLocalOnly(grand_totals);

            // Later properties overwrite earlier properties with the same name.
            comp.objectsToUpdate["parent"] = { ...comp.objectsToUpdate["parent"], ...totals };
            comp.objectsToUpdate["grand_parent"] = { ...comp.objectsToUpdate["grand_parent"], ...grand_totals };
        }, 50);

        // Save the row once finished editing
        clearTimeout(this.typingTimer[id]);
        this.typingTimer[id] = setTimeout(function () {
            ormAccomplishmentBudgetCapitalEquipmentUpdate(comp.objectsToUpdate[id]);
        }, 2500);

        // Parent Total
        clearTimeout(this.typingTimer["parent"]);
        this.typingTimer["parent"] = setTimeout(function () {
            if (comp.objectsToUpdate["parent"]) {
                ormAccomplishmentBudgetUpdate(comp.objectsToUpdate["parent"]);
                ormAccomplishmentBudgetUpdate(comp.objectsToUpdate["grand_parent"]);
            }
        }, 2500);
    };

    recalculateTotal = (deleteId) => {
        const { accomplishment_plan, ormAccomplishmentBudgetUpdate, budgets, capital_row, ormAccomplishmentBudgetCapitalEquipmentDelete } = this.props;



        var totals = {};
        var grand_totals = {};
        var leverage_array = [];
        var uniq;

        if (accomplishment_plan.status === "Started Request for Amendment Change" || accomplishment_plan.status === "Submitted Request for Amendment Change") {
            totals = {
                id: capital_row.id,
                funding_request_amend: 0,
                anticipated_leverage_amend: 0,
                total_amend: 0,
                leverage_source: null
            };
            capital_row._capital.forEach(function (p) {
                if (p.id !== deleteId) {
                    totals["funding_request_amend"] += (parseInt(p.funding_request) || 0);
                    totals["anticipated_leverage_amend"] += (parseInt(p.anticipated_leverage) || 0);
                    totals["total_amend"] += (parseInt(p.total) || 0);
                    leverage_array.push(p.leverage_source);
                }
            });
            uniq = [...new Set(leverage_array)];
            totals["leverage_source"] = uniq.filter(n => n).join(", ");

            grand_totals = {
                id: budgets.find(b => b.item === "Grand Total").id,
                funding_request_amend: totals["funding_request_amend"],
                anticipated_leverage_amend: totals["anticipated_leverage_amend"],
                total_amend: totals["total_amend"]
            };
            budgets.forEach(function (b) {
                if (b.item !== "Capital Equipment" && b.item !== "Grand Total") {
                    grand_totals["funding_request_amend"] += b.funding_request_amend;
                    grand_totals["anticipated_leverage_amend"] += b.anticipated_leverage_amend;
                    grand_totals["total_amend"] += b.total_amend;
                }
            });
        } else {
            totals = {
                id: capital_row.id,
                funding_request: 0,
                anticipated_leverage: 0,
                total: 0,
                leverage_source: null
            };
            capital_row._capital.forEach(function (p) {
                if (p.id !== deleteId) {
                    totals["funding_request"] += (parseInt(p.funding_request) || 0);
                    totals["anticipated_leverage"] += (parseInt(p.anticipated_leverage) || 0);
                    totals["total"] += (parseInt(p.total) || 0);
                    leverage_array.push(p.leverage_source);
                }
            });
            uniq = [...new Set(leverage_array)];
            totals["leverage_source"] = uniq.filter(n => n).join(", ");

            grand_totals = {
                id: budgets.find(b => b.item === "Grand Total").id,
                funding_request: totals["funding_request"],
                anticipated_leverage: totals["anticipated_leverage"],
                total: totals["total"]
            };
            budgets.forEach(function (b) {
                if (b.item !== "Capital Equipment" && b.item !== "Grand Total") {
                    grand_totals["funding_request"] += b.funding_request;
                    grand_totals["anticipated_leverage"] += b.anticipated_leverage;
                    grand_totals["total"] += b.total;
                }
            });
        }

        ormAccomplishmentBudgetCapitalEquipmentDelete(deleteId);
        ormAccomplishmentBudgetUpdate(totals);
        ormAccomplishmentBudgetUpdate(grand_totals);
    };

    updateForm = (field, id) => {
        this.formkeys[id + field] = window.performance.now();
        this.setState({ foo: "bar" });
    };

    render() {
        const { classes, capital_row, is_read_only } = this.props;

        return (
            <Table className={classes.table}>
                <EnhancedTableHead columnData={this.columnData} />
                <TableBody>
                    {capital_row && capital_row._capital.map(n => {
                        return (
                            <TableRow hover key={n.id}>
                                <CustomTableCell>
                                    <Form key={n.id + "position"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    tableFormat
                                                    eventHandleProps1={n.id}
                                                    eventHandleProps2={n}
                                                    eventHandle={this.updateRecord}
                                                    field="position"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={this.formkeys[n.id + "funding_request"] ? this.formkeys[n.id + "funding_request"] : n.id + "funding_request"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    onBlur={this.updateForm}
                                                    eventHandleProps1={n.id}
                                                    eventHandleProps2={n}
                                                    tableFormat
                                                    useTextFormat
                                                    eventHandle={this.updateRecord}
                                                    field="funding_request"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={this.formkeys[n.id + "anticipated_leverage"] ? this.formkeys[n.id + "anticipated_leverage"] : n.id + "anticipated_leverage"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    onBlur={this.updateForm}
                                                    eventHandleProps1={n.id}
                                                    eventHandleProps2={n}
                                                    tableFormat
                                                    useTextFormat
                                                    eventHandle={this.updateRecord}
                                                    field="anticipated_leverage"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={n.id + "leverage_source"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    tableFormat
                                                    eventHandleProps1={n.id}
                                                    eventHandle={this.updateRecord}
                                                    eventHandleProps2={n}
                                                    field="leverage_source"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    {numberRender(n.total)}
                                </CustomTableCell>
                                <CustomTableCell className={classes.nowrap}>
                                    <Tooltip title="Delete Record">
                                        <Button
                                            color="primary"
                                            disabled={is_read_only}
                                            className={classes.deleteWidth}
                                            onClick={() => this.recalculateTotal(n.id)}>
                                            <DeleteIcon color="primary" />
                                        </Button>
                                    </Tooltip>
                                </CustomTableCell>
                            </TableRow>
                        );
                    })}
                    {(!capital_row || capital_row._capital < 1) && (
                        <TableRow className={classes.totalRow2}>
                            <CustomTableCell colSpan={this.columnData.length} className={classes.centerAlign}>
                                No Records Found
                            </CustomTableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        );
    }
}

class BudgetTable extends Component {
    columnData = [
        { id: "item", label: "Item", allowSort: false },
        { id: "funding_request", label: "Funding Request", allowSort: false },
        { id: "anticipated_leverage", label: "Leverage", allowSort: false },
        { id: "leverage_source", label: "Leverage Source", allowSort: false },
        { id: "total", label: "Total", type: "numeric", allowSort: false },
    ];
    typingTimer = [];
    typingTimer2 = [];
    objectsToUpdate = [];
    formkeys = {};

    updateRecord = (value, element, id, record) => {
        const { ormAccomplishmentBudgetUpdate, ormAccomplishmentBudgetUpdateLocalOnly, rows } = this.props;
        const comp = this;
        var row = rows.find(r => r.item === "Grand Total");

        // Save each individual value locally
        clearTimeout(this.typingTimer2[id + element]);
        this.typingTimer2[id + element] = setTimeout(function () {

            if (element === "funding_request" || element === "anticipated_leverage")
                value = (Math.round(parseInt(value) / 100) * 100) || 0;

            var vals = {
                id: id,
                [element]: value
            }
            if (element === "funding_request") {
                if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage"])
                    vals["total"] = value + comp.objectsToUpdate[id]["anticipated_leverage"];
                else
                    vals["total"] = value + record.anticipated_leverage;
            }
            else if (element === "anticipated_leverage") {
                if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request"])
                    vals["total"] = value + comp.objectsToUpdate[id]["funding_request"];
                else
                    vals["total"] = value + record.funding_request;
            }
            ormAccomplishmentBudgetUpdateLocalOnly(vals);
            comp.objectsToUpdate[id] = { ...comp.objectsToUpdate[id], ...vals };

            if (element === "leverage_source")
                return;

            var totals = {
                id: row.id,
                funding_request: 0,
                anticipated_leverage: 0,
                total: 0
            };
            rows.forEach(function (p) {
                if (p.id !== row.id) {
                    if (p.id === id) {
                        if (element === "funding_request") {
                            totals["funding_request"] += value;
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage"])
                                totals["anticipated_leverage"] += comp.objectsToUpdate[id]["anticipated_leverage"];
                            else
                                totals["anticipated_leverage"] += (parseInt(p.anticipated_leverage) || 0);
                        }
                        else if (element === "anticipated_leverage") {
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request"])
                                totals["funding_request"] += comp.objectsToUpdate[id]["funding_request"];
                            else
                                totals["funding_request"] += (parseInt(p.funding_request) || 0);
                            totals["anticipated_leverage"] += value;
                        }
                        totals["total"] += vals["total"];
                    } else {
                        totals["funding_request"] += (parseInt(p.funding_request) || 0);
                        totals["anticipated_leverage"] += (parseInt(p.anticipated_leverage) || 0);
                        totals["total"] += (parseInt(p.total) || 0);
                    }
                }
            });

            ormAccomplishmentBudgetUpdateLocalOnly(totals);

            // Later properties overwrite earlier properties with the same name.
            comp.objectsToUpdate[row.id] = { ...comp.objectsToUpdate[row.id], ...totals };
        }, 50);

        // Save the row once finished editing
        clearTimeout(this.typingTimer[id]);
        this.typingTimer[id] = setTimeout(function () {
            ormAccomplishmentBudgetUpdate(comp.objectsToUpdate[id]);
        }, 2500);

        // Grand Total
        clearTimeout(this.typingTimer[row.id]);
        this.typingTimer[row.id] = setTimeout(function () {
            ormAccomplishmentBudgetUpdate(comp.objectsToUpdate[row.id]);
        }, 2500);
    };

    updateForm = (field, id) => {
        this.formkeys[id + field] = window.performance.now();
        this.setState({ foo: "bar" });
    };

    render() {
        const { rows, classes, is_read_only } = this.props;

        return (
            <Table className={classes.table}>
                <EnhancedTableHead columnData={this.columnData} />
                <TableBody>
                    {rows.map(n => {
                        if (n.item === "Grand Total") {
                            return (
                                <TableRow className={classes.totalRow}>
                                    <CustomTableCell><b>Grand Total</b></CustomTableCell>
                                    <CustomTableCell><b>{numberRender(n.funding_request)}</b></CustomTableCell>
                                    <CustomTableCell><b>{numberRender(n.anticipated_leverage)}</b></CustomTableCell>
                                    <CustomTableCell></CustomTableCell>
                                    <CustomTableCell><b>{numberRender(n.total)}</b></CustomTableCell>
                                </TableRow>
                            )
                        }
                        if (n.item === "Personnel" || n.item === "Capital Equipment") {
                            return (
                                <TableRow className={classes.totalRow2}>
                                    <CustomTableCell>{n.item}</CustomTableCell>
                                    <CustomTableCell>{numberRender(n.funding_request)}</CustomTableCell>
                                    <CustomTableCell>{numberRender(n.anticipated_leverage)}</CustomTableCell>
                                    <CustomTableCell>{n.leverage_source}</CustomTableCell>
                                    <CustomTableCell>{numberRender(n.total)}</CustomTableCell>
                                </TableRow>
                            )
                        }
                        return (
                            <TableRow hover key={n.id}>
                                <CustomTableCell>
                                    {n.item}
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={this.formkeys[n.id + "funding_request"] ? this.formkeys[n.id + "funding_request"] : n.id + "funding_request"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    onBlur={this.updateForm}
                                                    eventHandleProps1={n.id}
                                                    eventHandleProps2={n}
                                                    tableFormat
                                                    useTextFormat
                                                    eventHandle={this.updateRecord}
                                                    field="funding_request"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={this.formkeys[n.id + "anticipated_leverage"] ? this.formkeys[n.id + "anticipated_leverage"] : n.id + "anticipated_leverage"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    onBlur={this.updateForm}
                                                    eventHandleProps1={n.id}
                                                    eventHandleProps2={n}
                                                    tableFormat
                                                    useTextFormat
                                                    eventHandle={this.updateRecord}
                                                    field="anticipated_leverage"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={n.id + "leverage_source"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    tableFormat
                                                    eventHandleProps1={n.id}
                                                    eventHandle={this.updateRecord}
                                                    field="leverage_source"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    {numberRender(n.total)}
                                </CustomTableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        );
    }
}

class BudgetTableAmendment extends Component {
    columnData = [
        { id: "item", label: "Item", allowSort: false },
        { id: "funding_request", label: "Funding Request (original)", allowSort: false },
        { id: "funding_request_amend", label: "Funding Request (new)", allowSort: false },
        { id: "anticipated_leverage", label: "Leverage (original)", allowSort: false },
        { id: "anticipated_leverage_amend", label: "Leverage (new)", allowSort: false },
        { id: "leverage_source", label: "Leverage Source", allowSort: false },
        { id: "total", label: "Total (original)", type: "numeric", allowSort: false },
        { id: "total_amend", label: "Total (new)", type: "numeric", allowSort: false },
    ];
    typingTimer = [];
    typingTimer2 = [];
    objectsToUpdate = [];
    formkeys = {};

    updateRecord = (value, element, id, record) => {
        const { ormAccomplishmentBudgetUpdate, ormAccomplishmentBudgetUpdateLocalOnly, rows } = this.props;
        const comp = this;
        var row = rows.find(r => r.item === "Grand Total");

        // Save each individual value locally
        clearTimeout(this.typingTimer2[id + element]);
        this.typingTimer2[id + element] = setTimeout(function () {

            if (element === "funding_request_amend" || element === "anticipated_leverage_amend")
                value = (Math.round(parseInt(value) / 100) * 100) || 0;

            var vals = {
                id: id,
                [element]: value
            }
            if (element === "funding_request_amend") {
                if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage_amend"])
                    vals["total_amend"] = value + comp.objectsToUpdate[id]["anticipated_leverage_amend"];
                else
                    vals["total_amend"] = value + record.anticipated_leverage_amend;
            }
            else if (element === "anticipated_leverage_amend") {
                if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request_amend"])
                    vals["total_amend"] = value + comp.objectsToUpdate[id]["funding_request_amend"];
                else
                    vals["total_amend"] = value + record.funding_request;
            }
            ormAccomplishmentBudgetUpdateLocalOnly(vals);
            comp.objectsToUpdate[id] = { ...comp.objectsToUpdate[id], ...vals };

            if (element === "leverage_source")
                return;

            var totals = {
                id: row.id,
                funding_request_amend: 0,
                anticipated_leverage_amend: 0,
                total_amend: 0
            };
            rows.forEach(function (p) {
                if (p.id !== row.id) {
                    if (p.id === id) {
                        if (element === "funding_request_amend") {
                            totals["funding_request_amend"] += value;
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["anticipated_leverage_amend"])
                                totals["anticipated_leverage_amend"] += comp.objectsToUpdate[id]["anticipated_leverage_amend"];
                            else
                                totals["anticipated_leverage_amend"] += (parseInt(p.anticipated_leverage_amend) || 0);
                        }
                        else if (element === "anticipated_leverage_amend") {
                            if (comp.objectsToUpdate[id] && comp.objectsToUpdate[id]["funding_request_amend"])
                                totals["funding_request_amend"] += comp.objectsToUpdate[id]["funding_request_amend"];
                            else
                                totals["funding_request_amend"] += (parseInt(p.funding_request_amend) || 0);
                            totals["anticipated_leverage_amend"] += value;
                        }
                        totals["total_amend"] += vals["total_amend"];
                    } else {
                        totals["funding_request_amend"] += (parseInt(p.funding_request_amend) || 0);
                        totals["anticipated_leverage_amend"] += (parseInt(p.anticipated_leverage_amend) || 0);
                        totals["total_amend"] += (parseInt(p.total_amend) || 0);
                    }
                }
            });

            ormAccomplishmentBudgetUpdateLocalOnly(totals);

            // Later properties overwrite earlier properties with the same name.
            comp.objectsToUpdate[row.id] = { ...comp.objectsToUpdate[row.id], ...totals };
        }, 50);

        // Save the row once finished editing
        clearTimeout(this.typingTimer[id]);
        this.typingTimer[id] = setTimeout(function () {
            ormAccomplishmentBudgetUpdate(comp.objectsToUpdate[id]);
        }, 2500);

        // Grand Total
        clearTimeout(this.typingTimer[row.id]);
        this.typingTimer[row.id] = setTimeout(function () {
            ormAccomplishmentBudgetUpdate(comp.objectsToUpdate[row.id]);
        }, 2500);
    };

    updateForm = (field, id) => {
        this.formkeys[id + field] = window.performance.now();
        this.setState({ foo: "bar" });
    };

    render() {
        const { rows, classes, is_read_only } = this.props;

        return (
            <Table className={classes.table}>
                <EnhancedTableHead columnData={this.columnData} />
                <TableBody>
                    {rows.map(n => {
                        if (n.item === "Grand Total") {
                            return (
                                <TableRow className={classes.totalRow}>
                                    <CustomTableCell><b>Grand Total</b></CustomTableCell>
                                    <CustomTableCell><b>{numberRender(n.funding_request)}</b></CustomTableCell>
                                    <CustomTableCell><b>{numberRender(n.funding_request_amend)}</b></CustomTableCell>
                                    <CustomTableCell><b>{numberRender(n.anticipated_leverage)}</b></CustomTableCell>
                                    <CustomTableCell><b>{numberRender(n.anticipated_leverage_amend)}</b></CustomTableCell>
                                    <CustomTableCell></CustomTableCell>
                                    <CustomTableCell><b>{numberRender(n.total)}</b></CustomTableCell>
                                    <CustomTableCell><b>{numberRender(n.total_amend)}</b></CustomTableCell>
                                </TableRow>
                            )
                        }
                        if (n.item === "Personnel" || n.item === "Capital Equipment") {
                            return (
                                <TableRow className={classes.totalRow2}>
                                    <CustomTableCell>{n.item}</CustomTableCell>
                                    <CustomTableCell>{numberRender(n.funding_request)}</CustomTableCell>
                                    <CustomTableCell>{numberRender(n.funding_request_amend)}</CustomTableCell>
                                    <CustomTableCell>{numberRender(n.anticipated_leverage)}</CustomTableCell>
                                    <CustomTableCell>{numberRender(n.anticipated_leverage_amend)}</CustomTableCell>
                                    <CustomTableCell>{n.leverage_source}</CustomTableCell>
                                    <CustomTableCell>{numberRender(n.total)}</CustomTableCell>
                                    <CustomTableCell>{numberRender(n.total_amend)}</CustomTableCell>
                                </TableRow>
                            )
                        }
                        return (
                            <TableRow hover key={n.id}>
                                <CustomTableCell>
                                    {n.item}
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={true}
                                                    tableFormat
                                                    useTextFormat
                                                    field="funding_request"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={this.formkeys[n.id + "funding_request_amend"] ? this.formkeys[n.id + "funding_request_amend"] : n.id + "funding_request_amend"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    onBlur={this.updateForm}
                                                    eventHandleProps1={n.id}
                                                    eventHandleProps2={n}
                                                    tableFormat
                                                    useTextFormat
                                                    eventHandle={this.updateRecord}
                                                    field="funding_request_amend"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={true}
                                                    tableFormat
                                                    useTextFormat
                                                    field="anticipated_leverage"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={this.formkeys[n.id + "anticipated_leverage_amend"] ? this.formkeys[n.id + "anticipated_leverage_amend"] : n.id + "anticipated_leverage_amend"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    onBlur={this.updateForm}
                                                    eventHandleProps1={n.id}
                                                    eventHandleProps2={n}
                                                    tableFormat
                                                    useTextFormat
                                                    eventHandle={this.updateRecord}
                                                    field="anticipated_leverage_amend"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    <Form key={n.id + "leverage_source"} defaultValues={n}>
                                        {formApi => (
                                            <form onSubmit={formApi.submitForm}>
                                                <TextField
                                                    disabled={is_read_only}
                                                    tableFormat
                                                    eventHandleProps1={n.id}
                                                    eventHandle={this.updateRecord}
                                                    field="leverage_source"
                                                    label="NOLABEL"
                                                    fullWidth
                                                />
                                            </form>
                                        )}
                                    </Form>
                                </CustomTableCell>
                                <CustomTableCell>
                                    {numberRender(n.total)}
                                </CustomTableCell>
                                <CustomTableCell>
                                    {numberRender(n.total_amend)}
                                </CustomTableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        );
    }
}

class BudgetTableTotal extends Component {
    columnData = [
        { id: "item", label: "Item", allowSort: false },
        { id: "funding_request", label: "Funding Request", allowSort: false },
        { id: "anticipated_leverage", label: "Leverage", allowSort: false },
        { id: "leverage_source", label: "Leverage Source", allowSort: false },
        { id: "total", label: "Total", allowSort: false },
    ];

    shouldComponentUpdate(nextProps) {
        return nextProps.rows !== this.props.rows;
    };

    render() {
        const { classes, rows } = this.props;

        var groupedRows = [];
        budget_items.forEach(function (b) {
            groupedRows.push({ item: b, funding_request: 0, anticipated_leverage: 0, leverage_source: null, total: 0 });
        });
        rows.forEach(function (r, i) {
            var total = groupedRows.find(gr => gr.item === r.item);
            total["funding_request"] += r["funding_request"];
            total["anticipated_leverage"] += r["anticipated_leverage"];
            total["total"] += r["total"];
        });

        return (
            <Table className={classes.table}>
                <EnhancedTableHead columnData={this.columnData} />
                <TableBody>
                    {groupedRows.map(n => {
                        return (
                            <TableRow className={classes.totalRow2}>
                                <CustomTableCell> {n.item} </CustomTableCell>
                                <CustomTableCell> {numberRender(n.funding_request)} </CustomTableCell>
                                <CustomTableCell> {numberRender(n.anticipated_leverage)} </CustomTableCell>
                                <CustomTableCell></CustomTableCell>
                                <CustomTableCell> {numberRender(n.total)} </CustomTableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        );
    }
}

class BudgetTableTotalAmendment extends Component {
    columnData = [
        { id: "item", label: "Item", allowSort: false },
        { id: "funding_request", label: "Funding Request (original)", allowSort: false },
        { id: "funding_request_amend", label: "Funding Request (new)", allowSort: false },
        { id: "anticipated_leverage", label: "Leverage (original)", allowSort: false },
        { id: "anticipated_leverage_amend", label: "Leverage (new)", allowSort: false },
        { id: "leverage_source", label: "Leverage Source", allowSort: false },
        { id: "total", label: "Total (original)", allowSort: false },
        { id: "total_amend", label: "Total (new)", allowSort: false },
    ];

    shouldComponentUpdate(nextProps) {
        return nextProps.rows !== this.props.rows;
    };

    render() {
        const { classes, rows } = this.props;

        var groupedRows = [];
        budget_items.forEach(function (b) {
            groupedRows.push({ item: b, funding_request: 0, anticipated_leverage: 0, leverage_source: null, total: 0, funding_request_amend: 0, anticipated_leverage_amend: 0, total_amend: 0 });
        });
        rows.forEach(function (r, i) {
            var total = groupedRows.find(gr => gr.item === r.item);
            total["funding_request"] += r["funding_request"];
            total["anticipated_leverage"] += r["anticipated_leverage"];
            total["total"] += r["total"];
            total["funding_request_amend"] += r["funding_request_amend"];
            total["anticipated_leverage_amend"] += r["anticipated_leverage_amend"];
            total["total_amend"] += r["total_amend"];
        });

        return (
            <Table className={classes.table}>
                <EnhancedTableHead columnData={this.columnData} />
                <TableBody>
                    {groupedRows.map(n => {
                        return (
                            <TableRow className={classes.totalRow2}>
                                <CustomTableCell> {n.item} </CustomTableCell>
                                <CustomTableCell> {numberRender(n.funding_request)} </CustomTableCell>
                                <CustomTableCell> {numberRender(n.funding_request_amend)} </CustomTableCell>
                                <CustomTableCell> {numberRender(n.anticipated_leverage)} </CustomTableCell>
                                <CustomTableCell> {numberRender(n.anticipated_leverage_amend)} </CustomTableCell>
                                <CustomTableCell></CustomTableCell>
                                <CustomTableCell> {numberRender(n.total)} </CustomTableCell>
                                <CustomTableCell> {numberRender(n.total_amend)} </CustomTableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        );
    }
}

class RenamePartnership extends Component {
    state = {
        loading: false
    };
    rename = (values) => {
        const { budgets, ormAccomplishmentBudgetUpdate, returnDialog } = this.props;
        this.setState({ loading: true }, function () {
            budgets.forEach(function (b) {
                ormAccomplishmentBudgetUpdate({
                    id: b.id,
                    partnership: values.name
                });
            });
            returnDialog();
            this.setState({ loading: false });
        });
    }

    errorValidator = values => {
        const isRequired = val => {
            return !val ? "Required" : null;
        };
        var valObj = {
            name: isRequired(values.name)
        };

        return valObj;
    };

    render() {
        const { classes, open, returnDialog, name } = this.props;
        const { loading } = this.state;
        return (
            <Dialog open={open} classes={{ paper: classes.minWidth }}>
                <Toolbar>
                    <Typography variant="h3" className={classes.flex}>
                        Rename Partner
                    </Typography>
                    <IconButton aria-label="Close Dialog" onClick={() => returnDialog()}>
                        <Close />
                    </IconButton>
                </Toolbar>
                <DialogContent className={classes.dialogMin}>
                    <DialogContentText>
                        <Form
                            dontValidateOnMount={true}
                            validateOnSubmit={true}
                            validateError={this.errorValidator}
                            defaultValues={{ name: name }}
                            onSubmit={values => this.rename(values)}>
                            {formApi => (
                                <form onSubmit={formApi.submitForm}>
                                    <Grid container spacing={0}>
                                        <Grid item xs={12}>
                                            <TextField
                                                field="name"
                                                label="Partner Name"
                                                autoFocus
                                                fullWidth
                                            />
                                            <br /><br />
                                        </Grid>
                                        <Grid item xs={12}>
                                            {loading && (
                                                <CircularProgress size={24} />
                                            )}
                                            {!loading && (
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    color="primary">
                                                    Save
                                                </Button>
                                            )}
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Form>
                    </DialogContentText>
                </DialogContent>
            </Dialog>
        );
    }
}

class OtherFields extends Component {
    personneloptions = [
        { label: "Yes (Explain)", value: "true" },
        { label: "No", value: "false" }
    ];
    budgetscaleoptions = [
        { label: "Yes (Explain)", value: "true" },
        { label: "No (Explain)", value: "false" }
    ];

    applyOther = (value, element) => {
        const { ormAccomplishmentPlanUpdateLocalOnly, accomplishment_plan } = this.props;
        const { id } = accomplishment_plan;
        ormAccomplishmentPlanUpdateLocalOnly({
            id: id,
            [element]: value
        });
        this.setState({ foo: "bar" });
    };

    render() {
        const { accomplishment_plan, groupedItem, is_read_only } = this.props;

        const year = parseInt(accomplishment_plan.ml_year);
        const budget_scale_YES = getValue(accomplishment_plan, "budget_scale") === "true" || getValue(accomplishment_plan, "budget_scale") === true;
        const professional_services_YES = getValue(accomplishment_plan, "professional_services").indexOf("Other") > -1;
        const personnel_past_requested_YES = getValue(accomplishment_plan, "personnel_past_requested") === "true" || getValue(accomplishment_plan, "personnel_past_requested") === true;

        var has_contracts = false;
        groupedItem.get("Contracts").forEach(function (gi) {
            if (gi.funding_request > 0)
                has_contracts = true;
        });
        var has_professional = false;
        groupedItem.get("Professional Services").forEach(function (gi) {
            if (gi.funding_request > 0)
                has_professional = true;
        });
        var has_fee = false;
        groupedItem.get("Fee Acquisition w/ PILT").forEach(function (gi) {
            if (gi.funding_request > 0)
                has_fee = true;
        });
        groupedItem.get("Fee Acquisition w/o PILT").forEach(function (gi) {
            if (gi.funding_request > 0)
                has_fee = true;
        });
        var has_easement_stewardship = false;
        groupedItem.get("Easement Stewardship").forEach(function (gi) {
            if (gi.funding_request > 0)
                has_easement_stewardship = true;
        });
        var has_travel = false;
        groupedItem.get("Travel").forEach(function (gi) {
            if (gi.funding_request > 0)
                has_travel = true;
        });
        var has_direct_support_services = false;
        groupedItem.get("Direct Support Services").forEach(function (gi) {
            if (gi.funding_request > 0)
                has_direct_support_services = true;
        });
        var has_equipment = false;
        groupedItem.get("Other Equipment/Tools").forEach(function (gi) {
            if (gi.funding_request > 0)
                has_equipment = true;
        });
        var has_personnel = false;
        groupedItem.get("Personnel").forEach(function (gi) {
            if (gi.funding_request > 0)
                has_personnel = true;
        });
        var has_leverage = false;
        groupedItem.forEach(function (gi) {
            gi.forEach(function (gi2) {
                if (gi2.anticipated_leverage > 0)
                    has_leverage = true;
            });
        });

        return (
            <Grid item xs={12} lg={10} xl={7}>
                <TextField
                    field="reduced_appropriation"
                    label="How will this program accommodate the reduced appropriation recommendation from the original proposed requested amount?"
                    maxWords={!is_read_only && "50"}
                    disabled={is_read_only}
                    multiline
                    rows={4}
                    rowsMax={20}
                    fullWidth
                />
                {year >= 2017 && has_leverage && (
                    <TextField
                        field="explain_leverage"
                        label={
                            year >= 2024 ? "Detail leverage sources and confirmation of funds:" :
                                "Describe and explain leverage source and confirmation of funds."
                        }
                        maxWords={!is_read_only && "50"}
                        disabled={is_read_only}
                        multiline
                        rows={4}
                        rowsMax={20}
                        fullWidth
                    />
                )}
                {year >= 2022 && budget_scale_YES && (
                    <RadioGroup
                        field="budget_scale"
                        name="budget_scale"
                        disabled={true}
                        eventHandle={this.applyOther}
                        fullWidth
                        options={[
                            { label: "Yes (Explain)", value: "true" },
                            { label: "No", value: "false" }
                        ]}
                        alignment={true}
                        label="Does this project have the ability to be scalable?"
                    />
                )}
                {year >= 2022 && budget_scale_YES && (
                    <Typography variant="h3">
                        If the project received 50% of the requested funding
                    </Typography>
                )}
                {year >= 2022 && budget_scale_YES && (
                    <Subquestion component={
                        <TextField
                            field="budget_scale_yes_acres"
                            label="Describe how the scaling would affect acres/activities and if not proportionately reduced, why?"
                            maxWords={!is_read_only && "50"}
                            disabled={true}
                            multiline
                            rows={4}
                            rowsMax={20}
                            fullWidth
                        />
                    } />
                )}
                {year >= 2022 && budget_scale_YES && (
                    <Subquestion component={
                        <TextField
                            field="budget_scale_yes_personnel"
                            label="Describe how personnel and DSS expenses would be adjusted and if not proportionately reduced, why?"
                            maxWords={!is_read_only && "50"}
                            disabled={true}
                            multiline
                            rows={4}
                            rowsMax={20}
                            fullWidth
                        />
                    } />
                )}
                {year >= 2021 && has_personnel && (
                    <>
                        <Typography variant="h3">
                            Personnel
                        </Typography>
                        <Subquestion component={
                            <>
                                <RadioGroup
                                    field="personnel_past_requested"
                                    name="personnel_past_requested"
                                    eventHandle={this.applyOther}
                                    disabled={is_read_only}
                                    fullWidth
                                    options={this.personneloptions}
                                    alignment={true}
                                    label="Has funding for these positions been requested in the past?"
                                />
                                {personnel_past_requested_YES && (
                                    <Subquestion component={
                                        <TextField
                                            field="personnel_overlap"
                                            disabled={is_read_only}
                                            label="Please explain the overlap of past and future staffing and position levels previously received and how that is coordinated over multiple years?"
                                            multiline
                                            rows={4}
                                            rowsMax={20}
                                            fullWidth
                                        />
                                    } />
                                )}
                            </>
                        } />
                    </>
                )}
                {year >= 2017 && has_contracts && (
                    <>
                        <Typography variant="h3">
                            Contracts
                        </Typography>
                        <Subquestion component={
                            <TextField
                                field="contracts_included"
                                disabled={is_read_only}
                                label="What is included in the contracts line?"
                                maxWords={!is_read_only && "50"}
                                multiline
                                rows={4}
                                rowsMax={20}
                                fullWidth
                            />
                        } />
                    </>
                )}
                {year >= 2024 && has_professional && (
                    <>
                        <Typography variant="h3">
                            Professional Services
                        </Typography>
                        <Subquestion component={
                            <>
                                <CheckboxGroup
                                    field="professional_services"
                                    label="What is included in the Professional Services line?"
                                    row={true}
                                    width={205}
                                    disabled={is_read_only}
                                    eventHandle={this.applyOther}
                                    options={MAKE_OPTIONS([
                                        "Appraisals",
                                        "Surveys",
                                        "Design/Engineering",
                                        "Title Insurance and Legal Fees",
                                        "Other"
                                    ])}
                                />
                                {professional_services_YES && (
                                    <TextField
                                        field="professional_services_other"
                                        disabled={is_read_only}
                                        label="What is your other profressional service?"
                                        fullWidth
                                    />
                                )}
                            </>
                        } />
                    </>
                )}
                {year >= 2021 && has_fee && (
                    <>
                        <Typography variant="h3">
                            Fee Acquisition
                        </Typography>
                        <Subquestion component={
                            <TextField
                                field="anticipated_fee_transactions"
                                disabled={is_read_only}
                                label="What is the anticipated number of fee title acquisition transactions?"
                                multiline
                                rows={4}
                                rowsMax={20}
                                fullWidth
                            />
                        } />
                    </>
                )}
                {year >= 2017 && has_easement_stewardship && (
                    <>
                        <Typography variant="h3">
                            Easement Stewardship
                        </Typography>
                        <Subquestion component={
                            <TextField
                                field="cost_per_easement"
                                disabled={is_read_only}
                                label="What is the number of easements anticipated, cost per easement for stewardship, and explain how that amount is calculated?"
                                multiline
                                rows={4}
                                rowsMax={20}
                                fullWidth
                            />
                        } />
                    </>
                )}
                {year >= 2017 && has_travel && (
                    <>
                        <Typography variant="h3">
                            Travel
                        </Typography>
                        <Subquestion component={
                            <>
                                <RadioGroup
                                    field="travel_equipment"
                                    disabled={is_read_only}
                                    name="travel_equipment"
                                    fullWidth
                                    options={[
                                        { label: "Yes", value: "true" },
                                        { label: "No", value: "false" }
                                    ]}
                                    alignment={true}
                                    label="Does the amount in the travel line include equipment/vehicle rental?"
                                />
                                <TextField
                                    field="travel_outside_traditional"
                                    disabled={is_read_only}
                                    label="Explain the amount in the travel line outside of traditional travel costs of mileage, food, and lodging."
                                    multiline
                                    rows={4}
                                    rowsMax={20}
                                    fullWidth
                                />
                                {year >= 2021 && (
                                    <Checkbox
                                        field="attest_travel"
                                        disabled={is_read_only}
                                        label="I understand and agree that lodging, meals, and mileage must comply with the current MMB Commissioner Plan."
                                    />
                                )}
                            </>
                        } />
                    </>
                )}
                {has_direct_support_services && (
                    <>
                        <Typography variant="h3">
                            Direct Support Services
                        </Typography>
                        <Subquestion component={
                            <TextField
                                field="direct_services_portion"
                                disabled={is_read_only}
                                label="How did you determine which portions of the Direct Support Services of your shared support services is direct to this program?"
                                fullWidth
                                multiline
                                rows={4}
                                rowsMax={20}
                            />
                        } />
                    </>
                )}
                {year >= 2021 && has_equipment && (
                    <>
                        <Typography variant="h3">
                            Other Equipment/Tools
                        </Typography>
                        <Subquestion component={
                            <TextField
                                field="equipment_examples"
                                disabled={is_read_only}
                                label="Give examples of the types of Equipment and Tools that will be purchased?"
                                fullWidth
                                multiline
                                rows={4}
                                rowsMax={20}
                            />
                        } />
                    </>
                )}
            </Grid>
        )
    }
}

BudgetTab = connect(
    (state, ownProps) => ({
        budgets: getBudgets(state, ownProps),
        authState: state.auth
    }),
    {
        ...AccomplishmentPlan.actions,
        ...AccomplishmentBudget.actions,
        ...AccomplishmentBudgetPersonnel.actions,
        ...AccomplishmentBudgetCapitalEquipment.actions
    }
)(BudgetTab);

export default withStyles(styles)(withRouter(BudgetTab));
